import app from "js/legacy-app";

app.controller('ViewOrganisationCtrl', ['$scope', function ($scope) {
}]);